import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const NormalizePath = () => {
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        const lowercasePath = location.pathname.toLowerCase()
        if (location.pathname !== lowercasePath) {
            navigate(lowercasePath + location.search + location.hash, { replace: true })
        }
    }, [location, navigate])

    return null
}

export default NormalizePath
